import { nowIsoUtc } from "@nijiurachan/js/util/time";
import { useEffect, useState } from "react";
import { R18BlurOnboardingModal } from "@/features/r18-blur-onboarding/components/R18BlurOnboardingModal";
import {
  completeR18BlurOnboarding,
  shouldShowR18BlurOnboarding,
  subscribeR18BlurOnboardingReset,
} from "@/features/r18-blur-onboarding/lib/r18BlurOnboarding";

// モーダル本体はlazyにしない。共通Modal(overlay chunk)とmotionは変更前から
// 初期preloadに含まれており(dist/index.htmlで確認)、分けても初回訪問時の
// モーダル表示に動的import待ちが増えるだけになる。

/**
 * R18ぼかし案内モーダルの出し分け。「OK」を押したことがない人 (=初来訪者) に
 * だけ表示する。backdrop/Escapeで閉じた場合は承認記録せず、次回また表示する。
 * 「全データをクリア」で承認記録がresetされたときは、リロード無しでも即座に
 * 再表示する (resetSettingsで選択状態も初期化されるため、モーダル側が
 * クッションONへ戻し、ぼかし無しのまま閲覧が続くことはない)。
 */
export const R18BlurOnboardingGate: React.FunctionComponent = () => {
  // 初回描画時の判定を保持する。localStorage拒否時は毎回初回扱いになる。
  const [shouldMount, setShouldMount] = useState(() =>
    shouldShowR18BlurOnboarding(),
  );
  const [isOpen, setIsOpen] = useState(shouldMount);

  useEffect(
    () =>
      subscribeR18BlurOnboardingReset(() => {
        setShouldMount(true);
        setIsOpen(true);
      }),
    [],
  );

  // 承認済みの再訪者には何も描画しない。閉じた後はexitアニメーションの
  // ためにマウントを維持する(isOpen=falseでModalは何も表示しない)。
  if (!shouldMount) return null;

  return (
    <R18BlurOnboardingModal
      isOpen={isOpen}
      onDismiss={(): void => setIsOpen(false)}
      onComplete={(): void => {
        completeR18BlurOnboarding(nowIsoUtc());
        setIsOpen(false);
      }}
    />
  );
};
